import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  getAllYardAction,
  addNewYard,
  addNewYardRow,
  gatAllYardRowAction,
  updateYardRow,
  updateYard,
  getAllPaymentTypes,
  getAllWarehouses,
  getAllInventoryItemStatuses,
  addNewPaymentType,
  updatePaymentTypeRow,
  addNewWarehouse,
  updateWarehouse,
  addNewInventoryItemStatus,
  updateInventoryItemStatus,
  getAllFileCompressionConfigs,
  addUpdateFileCompressionConfig,
  getAllBannedItems,
  addNewBannedItem,
  updateBannedItem,
  addNewApprovalUser,
  updateApprovalUser,
  getAllApprovalUser,
  getActiveApprovalUsers,
  addNewTerminal,
  updateTerminal,
  getTerminal,
  updateTaxTypeRow,
  addNewTaxType,
  getAllTaxTypes,
  addNewShed,
  updateShad,
  getAllShads,
  updatePartyName,
  addPartyName,
  getAllPartName,
  addPartyNominationType,
  updatePartyNominationType,
  getAllPartyNominationType,
  getAllStorageSlab,
  getAllAgents,
} from "./actions/configurationActions";

// Define a type for the slice state
interface GateEntryState {
  loader: true | false;
  terminalList: [];
  //------------------------
  allYardList: [];
  allYardRowsList: [];
  allPaymentTypeRowsList: [];
  allTaxTypeRowsList: [];
  allPartyNameList: [];
  allPartyNominationList: [];
  allApprovalUserList: [];
  allActiveApprovalUserList: [];
  allWarehousesList: [];
  allShadList: [];
  allInventoryItemStatusesList: [];
  allFileCompressionConfigsList: [];
  allBannedItemsList: [];
  formIsDirty: boolean;
  allStorageSlab: [];
  allagents: [];
}
const initialState: GateEntryState = {
  loader: false,
  terminalList: [],
  //---------------------------------
  allYardList: [],
  allYardRowsList: [],
  allPaymentTypeRowsList: [],
  allTaxTypeRowsList: [],
  allPartyNameList: [],
  allPartyNominationList: [],
  allApprovalUserList: [],
  allWarehousesList: [],
  allShadList: [],
  allActiveApprovalUserList: [],
  allInventoryItemStatusesList: [],
  allFileCompressionConfigsList: [],
  allBannedItemsList: [],
  formIsDirty: false,
  allStorageSlab: [],
  allagents: [],
};

export const configurationSlice = createSlice({
  name: "configuration",
  initialState: initialState,
  reducers: {
    // handle Synchronous Calls
    setisDirtyValue: (state: any, value) => {
      state.formIsDirty = value.payload;
    },
  },
  extraReducers: (builder) => {
    // handle Asynchronous Calls

    builder.addCase(addNewTerminal.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewTerminal.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewTerminal.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(updateTerminal.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateTerminal.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateTerminal.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(getTerminal.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getTerminal.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getTerminal.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.terminalList = payload;
    });

    //-----------------------------------------------------------------------------------------------
    builder.addCase(addNewApprovalUser.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewApprovalUser.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewApprovalUser.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(updateApprovalUser.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateApprovalUser.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateApprovalUser.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(getAllApprovalUser.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllApprovalUser.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllApprovalUser.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allApprovalUserList = payload;
    });

    builder.addCase(getActiveApprovalUsers.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getActiveApprovalUsers.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getActiveApprovalUsers.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allActiveApprovalUserList = payload;
    });
    /*************************** Start of YARD methods ****************************/
    // Get getAllYards methods
    builder.addCase(getAllYardAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllYardAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllYardAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allYardList = payload;
    });
    // ./getAllYards methods

    // Post Add Yard methods
    builder.addCase(addNewYard.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewYard.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewYard.fulfilled, (state) => {
      state.loader = false;
    });
    // ./Post Add Yard methods
    // PUT Update Yard methods
    builder.addCase(updateYard.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateYard.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateYard.fulfilled, (state) => {
      state.loader = false;
    });
    // ./PUT Update Yard methods
    // Get getAllYardRows methods
    builder.addCase(gatAllYardRowAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(gatAllYardRowAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(gatAllYardRowAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allYardRowsList = payload;
    });
    // ./getAllYardRows methods
    // Post Add Yard Row methods
    builder.addCase(addNewYardRow.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewYardRow.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewYardRow.fulfilled, (state) => {
      state.loader = false;
    });
    // ./Post Add Yard Row methods
    // PUT Update Yard Row methods
    builder.addCase(updateYardRow.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateYardRow.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateYardRow.fulfilled, (state) => {
      state.loader = false;
    });
    // ./PUT Update Yard Row methods
    /**************************** End of YARD methods *****************************/

    /********************* Start of Payment Type methods *************************/
    // Get getAllPaymentTypes methods
    builder.addCase(getAllPaymentTypes.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllPaymentTypes.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllPaymentTypes.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allPaymentTypeRowsList = payload;
    });

    // ./getAllPaymentTypes methods
    // Post addNewPaymentType methods
    builder.addCase(addNewPaymentType.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewPaymentType.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewPaymentType.fulfilled, (state) => {
      state.loader = false;
    });

    // party name methods
    builder.addCase(addPartyName.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addPartyName.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addPartyName.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(updatePartyName.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updatePartyName.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updatePartyName.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(getAllPartName.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllPartName.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllPartName.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allPartyNameList = payload?.nominationPartiesList;
    });
    builder.addCase(getAllStorageSlab.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllStorageSlab.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllStorageSlab.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allStorageSlab = payload;
    });
    builder.addCase(getAllAgents.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllAgents.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllAgents.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allagents = payload;
    });

    builder.addCase(addPartyNominationType.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addPartyNominationType.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addPartyNominationType.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(updatePartyNominationType.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updatePartyNominationType.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updatePartyNominationType.fulfilled, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllPartyNominationType.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllPartyNominationType.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllPartyNominationType.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allPartyNominationList = payload?.partyNominationList;
    });
    // ./addNewPaymentType methods
    // PUT updatePaymentTypeRow methods
    builder.addCase(updatePaymentTypeRow.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updatePaymentTypeRow.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updatePaymentTypeRow.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(addNewTaxType.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewTaxType.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewTaxType.fulfilled, (state) => {
      state.loader = false;
    });
    builder.addCase(updateTaxTypeRow.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateTaxTypeRow.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateTaxTypeRow.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(getAllTaxTypes.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllTaxTypes.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllTaxTypes.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allTaxTypeRowsList = payload?.taxRates;
    });
    // ./updatePaymentTypeRow methods
    /********************** End of Payment Type methods ***************************/

    /********************* Start of Warehouse methods *************************/
    // Get getAllWarehouses methods

    builder.addCase(getAllWarehouses.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllWarehouses.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllWarehouses.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allWarehousesList = payload;
    });
    // ./getAllWarehouses methods
    // Post addNewWarehouse methods
    builder.addCase(addNewWarehouse.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewWarehouse.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewWarehouse.fulfilled, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewShed.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewShed.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewShed.fulfilled, (state) => {
      state.loader = false;
    });
    // ./addNewWarehouse methods
    // PUT updateWarehouse methods
    builder.addCase(updateShad.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateShad.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateShad.fulfilled, (state) => {
      state.loader = false;
    });

    builder.addCase(getAllShads.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllShads.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllShads.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allShadList = payload?.shedList;
    });

    builder.addCase(updateWarehouse.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateWarehouse.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateWarehouse.fulfilled, (state) => {
      state.loader = false;
    });
    // ./updateWarehouse methods
    /********************** End of Warehouse methods **************************/

    /********************* Start of Inventory methods *************************/
    // Get getAllInventoryItemStatuses methods
    builder.addCase(getAllInventoryItemStatuses.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllInventoryItemStatuses.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllInventoryItemStatuses.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allInventoryItemStatusesList = payload;
    });
    // ./getAllInventoryItemStatuses methods
    // Post addNewInventoryItemStatus methods
    builder.addCase(addNewInventoryItemStatus.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewInventoryItemStatus.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewInventoryItemStatus.fulfilled, (state) => {
      state.loader = false;
    });
    // ./addNewInventoryItemStatus methods
    // PUT updateInventoryItemStatus methods
    builder.addCase(updateInventoryItemStatus.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateInventoryItemStatus.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateInventoryItemStatus.fulfilled, (state) => {
      state.loader = false;
    });
    // ./updateInventoryItemStatus methods
    /********************** End of Inventory methods **************************/

    /********************* Start of File Compression methods *************************/
    // Get getAllFileCompressionConfigs methods
    builder.addCase(getAllFileCompressionConfigs.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllFileCompressionConfigs.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllFileCompressionConfigs.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allFileCompressionConfigsList = payload;
    });
    // ./getAllFileCompressionConfigs methods
    // Post addUpdateFileCompressionConfig methods
    builder.addCase(addUpdateFileCompressionConfig.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addUpdateFileCompressionConfig.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addUpdateFileCompressionConfig.fulfilled, (state) => {
      state.loader = false;
    });
    // ./addUpdateFileCompressionConfig methods
    /********************** End of File Compression methods **************************/

    /********************* Start of BannedItem methods *************************/
    // Get getAllBannedItems methods
    builder.addCase(getAllBannedItems.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllBannedItems.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllBannedItems.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allBannedItemsList = payload;
    });
    // ./getAllBannedItems methods
    // Post addNewBannedItem methods
    builder.addCase(addNewBannedItem.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addNewBannedItem.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addNewBannedItem.fulfilled, (state) => {
      state.loader = false;
    });
    // ./addNewBannedItem methods
    // PUT updateBannedItem methods
    builder.addCase(updateBannedItem.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateBannedItem.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateBannedItem.fulfilled, (state) => {
      state.loader = false;
    });
    // ./updateBannedItem methods
    /********************** End of BannedItem methods **************************/
  },
});

export const loader = (state: RootState) => state.configuration.loader;
export const selectTerminalList = (state: RootState) => state.configuration.terminalList;

//--------------------------------------------
export const selectAllYardsList = (state: RootState) => state.configuration.allYardList;
export const selectAllYardRowsList = (state: RootState) => state.configuration.allYardRowsList;
export const selectAllPaymentTypeRowsList = (state: RootState) =>
  state.configuration.allPaymentTypeRowsList;
export const selectAllTaxTypeRowsList = (state: RootState) =>
  state.configuration.allTaxTypeRowsList;
export const selectAllPartyNameRowsList = (state: RootState) =>
  state.configuration.allPartyNameList;
export const selectAllStorageSlab = (state: RootState) => state.configuration.allStorageSlab;
export const selectAllAgent = (state: RootState) => state.configuration.allagents;
export const selectAllPartyNominationsNameRowsList = (state: RootState) =>
  state.configuration.allPartyNominationList;
export const selectAllApprovalUserList = (state: RootState) =>
  state.configuration.allApprovalUserList;
export const selectAllActiveApprovalUserList = (state: RootState) =>
  state.configuration.allActiveApprovalUserList;
export const selectAllWarehousesList = (state: RootState) => state.configuration.allWarehousesList;
export const selectAllShadList = (state: RootState) => state.configuration.allShadList;
export const selectAllInventoryItemStatusesList = (state: RootState) =>
  state.configuration.allInventoryItemStatusesList;
export const selectAllFileCompressionConfigsList = (state: RootState) =>
  state.configuration.allFileCompressionConfigsList;
export const selectAllBannedItemsList = (state: RootState) =>
  state.configuration.allBannedItemsList;
export const formIsDirty = (state: RootState) => state.configuration.formIsDirty;
export const { setisDirtyValue } = configurationSlice.actions;
